let searchModal = {
  load() {
    // =========================================================================
    // Search modal
    // =========================================================================
    $(function () {
      const $modal = $(".SearchContentModal");
      const $openBtn = $(".SiteHeader-searchTrigger");
      const $closeBtn = $(".SearchContentModal-close");
      const $body = $("body");

      let lastFocusedElement = null;

      const FOCUSABLE_SELECTORS = [
        "a[href]",
        "area[href]",
        'input:not([disabled]):not([type="hidden"])',
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        '[tabindex]:not([tabindex="-1"])',
      ].join(",");

      function getFocusableElements() {
        return $modal.find(FOCUSABLE_SELECTORS).filter(":visible").toArray();
      }

      function openModal() {
        lastFocusedElement = document.activeElement;

        $modal.removeAttr("hidden").addClass("active");
        $body.addClass("no-scroll");
        $openBtn.attr("aria-expanded", "true");

        const searchInput = document.getElementById("s");
        const focusables = getFocusableElements();

        if (searchInput) {
          searchInput.focus();
        } else if (focusables.length) {
          focusables[0].focus();
        }
      }

      function closeModal() {
        $modal.addClass("closing").removeClass("active");

        // petit timeout si tu veux garder une anim CSS
        setTimeout(() => {
          $modal.attr("hidden", true).removeClass("closing");
        }, 150);

        $body.removeClass("no-scroll");
        $openBtn.attr("aria-expanded", "false");

        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }

      $openBtn.on("click", function (e) {
        e.preventDefault();
        openModal();
      });

      $closeBtn.on("click", function () {
        closeModal();
      });

      // Fermeture si clic sur l’overlay
      $modal.on("click", function (e) {
        if (
          $(e.target).hasClass("SearchContentModal") ||
          $(e.target).hasClass("SearchContentModal-overlay")
        ) {
          closeModal();
        }
      });

      // Gestion clavier : Escape + focus trap
      $(document).on("keydown", function (e) {
        if (!$modal.hasClass("active")) return;

        if (e.key === "Escape") {
          e.preventDefault();
          closeModal();
          return;
        }

        if (e.key === "Tab") {
          const focusables = getFocusableElements();

          if (!focusables.length) {
            e.preventDefault();
            return;
          }

          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          if (e.shiftKey) {
            if (
              document.activeElement === first ||
              !$.contains($modal[0], document.activeElement)
            ) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (
              document.activeElement === last ||
              !$.contains($modal[0], document.activeElement)
            ) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      });
    });
  },
};

export default searchModal;
